var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppButtonsAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 135 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "91.488%",
    x2: "-38.352%",
    y1: "4.948%",
    y2: "71.907%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "107.685%",
    x2: "-130.64%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ffa500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "86.219%",
    x2: "-50.15%",
    y1: "17.877%",
    y2: "194.703%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "-18.754%",
    x2: "42.121%",
    y1: "-54.052%",
    y2: "24.917%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 40,
    rx: 5,
    width: 135
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.42 10.24a2.71 2.71 0 0 1 -.75 2 2.91 2.91 0 0 1 -2.2.89 3.15 3.15 0 0 1 -2.21-5.37 3 3 0 0 1 2.21-.9 3.1 3.1 0 0 1 1.23.25c.362.146.684.376.94.67l-.53.53a2 2 0 0 0 -1.64-.71 2.32 2.32 0 0 0 -2.33 2.4 2.36 2.36 0 0 0 4 1.73 1.89 1.89 0 0 0 .5-1.22h-2.17v-.72h2.91c.027.149.04.3.04.45zm4.58-2.5h-2.7v1.9h2.46v.72h-2.46v1.9h2.7v.74h-3.5v-6h3.5zm3.28 5.26h-.77v-5.26h-1.68v-.74h4.17v.74h-1.72zm4.66 0v-6h.77v6zm4.19 0h-.77v-5.26h-1.68v-.74h4.12v.74h-1.67zm9.48-.78a3.12 3.12 0 0 1 -4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.4 0 3.23 3.23 0 0 1 0 4.45zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0 -3.26 0 2.56 2.56 0 0 0 0 3.44zm5.8 1.28v-6h.94l2.92 4.67v-4.67h.77v6h-.8l-3.05-4.89v4.89z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.14 21.75a4.25 4.25 0 1 0 4.27 4.25 4.19 4.19 0 0 0 -4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1 -2.4 2.58zm-9.31-6.83a4.25 4.25 0 1 0 4.26 4.25 4.19 4.19 0 0 0 -4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.39-2.58 2.46 2.46 0 0 1 -2.4 2.58zm-11.09-5.52v1.8h4.32a3.77 3.77 0 0 1 -1 2.27 4.42 4.42 0 0 1 -3.33 1.32 4.8 4.8 0 1 1 0-9.6 4.6 4.6 0 0 1 3.27 1.29l1.27-1.27a6.29 6.29 0 0 0 -4.53-1.87 6.61 6.61 0 1 0 0 13.21 6 6 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.22 5.87 5.87 0 0 0 -.1-1.13zm45.31 1.4a4 4 0 0 0 -3.64-2.71 4 4 0 0 0 -4 4.25 4.16 4.16 0 0 0 4.22 4.25 4.23 4.23 0 0 0 3.54-1.88l-1.45-1a2.43 2.43 0 0 1 -2.09 1.18 2.16 2.16 0 0 1 -2.06-1.29l5.69-2.35zm-5.8 1.42a2.33 2.33 0 0 1 2.22-2.48 1.65 1.65 0 0 1 1.58.9zm-4.62 4.12h1.87v-12.5h-1.87zm-3.06-7.3h-.07a3 3 0 0 0 -2.24-1 4.26 4.26 0 0 0 0 8.51 2.9 2.9 0 0 0 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1 -2.14-1.51l-1.63.68a4.05 4.05 0 0 0 3.77 2.51c2.19 0 4-1.29 4-4.43v-7.57h-1.72zm-2.14 5.88a2.59 2.59 0 0 1 0-5.16 2.4 2.4 0 0 1 2.27 2.58 2.38 2.38 0 0 1 -2.28 2.58zm24.38-11.08h-4.47v12.5h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6h-2.61v-4.26h2.65a2.145 2.145 0 1 1 0 4.29zm11.53-1.8a3.5 3.5 0 0 0 -3.33 1.91l1.66.69a1.77 1.77 0 0 1 1.7-.92 1.8 1.8 0 0 1 2 1.61v.13a4.13 4.13 0 0 0 -1.95-.48c-1.79 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3.1 2.75 2.63 2.63 0 0 0 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1 -2.19 2zm10.63-6.55-2.14 5.42h-.06l-2.22-5.42h-2l3.33 7.58-1.9 4.21h1.95l5.12-11.79zm-16.81 8h1.87v-12.5h-1.87z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.44 7.54a2 2 0 0 0 -.46 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07 12.39-12.38v-.29l-12.39-12.39z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 24.28-4.1-4.13v-.29l4.1-4.14.09.05 4.91 2.79c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.12 24.22-4.22-4.22-12.46 12.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.12 15.78-14.61-8.3a1.63 1.63 0 0 0 -2.08.06l12.47 12.46z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 24.13-14.49 8.25a1.67 1.67 0 0 1 -2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.44 32.32a2 2 0 0 1 -.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07zm21.56-11.02-5 2.83.09.09 4.91-2.78a1.75 1.75 0 0 0 1-1.44 1.86 1.86 0 0 1 -1 1.3z",
    fill: "#000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.51 7.62 19.49 11.08a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0 -1-1.44l-19.49-11.08c-1.4-.79-2.54-.13-2.54 1.47v.15c.03-1.61 1.15-2.27 2.54-1.48z",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppButtonsAndroid);
export default __webpack_public_path__ + "static/media/AppButtonsAndroid.f13756b6f9783e32e992751c4eb058d5.svg";
export { ForwardRef as ReactComponent };